import type React from "react";
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const UserOfferings: React.FC = () => {
  const navigate = useNavigate()
  
  useEffect(() => {
    // Redirect to the enhanced user offerings page
    navigate('/user-offerings')
  }, [navigate])
  
  // Show a loading message while redirecting
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div>Loading enhanced offerings...</div>
    </div>
  )
}

export default UserOfferings;
